import { useEffect } from "react";
import { PageHead } from "../../ui/index.js";
import { BillingSection } from "./BillingSection.js";
import { DomainsSection } from "./DomainsSection.js";
import { ExamplesSection } from "./ExamplesSection.js";
import { BusinessSection, DangerSection, LimitsSection, PauseSection, RoutingSection } from "./GeneralSections.js";
import { InboxesSection } from "./InboxesSection.js";
import { KeysSection } from "./KeysSection.js";
import { MembersSection } from "./MembersSection.js";

const SECTIONS = [
  { id: "business", label: "Business" },
  { id: "billing", label: "Billing" },
  { id: "routing", label: "Routing" },
  { id: "limits", label: "Limits" },
  { id: "inboxes", label: "Inboxes" },
  { id: "domain", label: "Email Domain Settings" },
  { id: "members", label: "Members" },
  { id: "keys", label: "API keys" },
  { id: "examples", label: "Examples" },
  { id: "pause", label: "Pause" },
  { id: "danger", label: "Danger zone" },
] as const;

/** Scrolls to the section named in the URL hash, as in a link to /settings#domain. */
function useScrollToHash(): void {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id !== "") document.getElementById(id)?.scrollIntoView({ block: "start" });
  }, []);
}

export function SettingsScreen() {
  useScrollToHash();
  return (
    <>
      <PageHead title="Settings" />
      <div className="settings">
        <nav className="settings-nav" aria-label="Settings sections">
          {SECTIONS.map((section) => (
            <a key={section.id} href={`#${section.id}`}>
              {section.label}
            </a>
          ))}
        </nav>
        <div className="stack-lg settings-body">
          <BusinessSection />
          <BillingSection />
          <RoutingSection />
          <LimitsSection />
          <InboxesSection />
          <DomainsSection />
          <MembersSection />
          <KeysSection />
          <ExamplesSection />
          <PauseSection />
          <DangerSection />
        </div>
      </div>
    </>
  );
}
